var map = {
	"./diamond-color-1.png": 118,
	"./diamond-color-1@2x.png": 66,
	"./diamond-color-1@3x.png": 67,
	"./diamond-color-2.png": 119,
	"./diamond-color-2@2x.png": 68,
	"./diamond-color-2@3x.png": 69,
	"./diamond-color-3.png": 120,
	"./diamond-color-3@2x.png": 70,
	"./diamond-color-3@3x.png": 71,
	"./diamond-color-4.png": 121,
	"./diamond-color-4@2x.png": 72,
	"./diamond-color-4@3x.png": 73,
	"./diamond-color-5.png": 122,
	"./diamond-color-5@2x.png": 74,
	"./diamond-color-5@3x.png": 75,
	"./diamond-color-table.png": 123,
	"./diamond-color-table@2x.png": 76,
	"./diamond-color-table@3x.png": 77,
	"./diamond-color-table_over-md.png": 124,
	"./diamond-color-table_over-md@2x.png": 78,
	"./diamond-color-table_over-md@3x.png": 79
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 252;